import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { ConversationResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof ConversationResponseDataSchema>>
type Options = {
  refetchInterval?: number
  enabled?: boolean
  onSuccess?: (data: Response) => void
}

export const getConversationQueryKey = (id: string) => ["conversations", id]

export const conversationQuery = (id: string, options: Options = {}) => {
  return queryOptions({
    queryKey: getConversationQueryKey(id),
    placeholderData: undefined,
    queryFn: async () => {
      const response = await axios.get<Response>(`/conversations/${id}`)

      options.onSuccess?.(response.data)

      return response.data.data
    },
    refetchInterval: options.refetchInterval,
    enabled: options.enabled,
  })
}
